import React__default from "react";
const AccordionItemContext = React__default.createContext({
  accordionRef: (
    /* istanbul ignore next */
    () => null
  ),
  id: "id-0",
  // cannot be an empty string
  onClick: (
    /* istanbul ignore next */
    () => null
  )
});
export {
  AccordionItemContext
};
